import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Render error:', error, info.componentStack);
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="mx-auto max-w-lg py-16 text-center">
          <h1 className="font-display text-2xl text-cream-50">Something went wrong</h1>
          <p className="mt-3 text-sm text-cream-300/70">
            An unexpected error occurred. Try refreshing the page.
          </p>
          <div className="mt-6 flex justify-center gap-3">
            <button className="btn-primary" onClick={() => window.location.reload()}>
              Refresh
            </button>
            <Link to="/" className="btn-ghost">
              Go home
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export function RouteErrorPage() {
  return (
    <div className="mx-auto max-w-lg py-16 text-center">
      <h1 className="font-display text-2xl text-cream-50">Page unavailable</h1>
      <p className="mt-3 text-sm text-cream-300/70">This page could not be loaded.</p>
      <Link to="/" className="btn-primary mt-6 inline-block">
        Go home
      </Link>
    </div>
  );
}
